module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Cupboard-e88e149ba0fd974a941934b774da3c14.svg";